export default "__VITE_ASSET__BzntY9mp__"